import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import ProjetoCulturalService from '../../../../../services/projetoCultural-auth';
import { Link } from 'react-router-dom';
import '../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [patrocinador, setPatrocinador] = useState("");
    const [beneficiario, setBeneficiario] = useState("");
    const [andamento, setAndamento] = useState("");
    

    const busca = async (query) => {
        if (query == "") {
            await props.fetchProjetos()
            setPatrocinador("")
            setBeneficiario("")
            setAndamento("")
        } else {
            var response = await ProjetoCulturalService.buscar(query)
            if (response.data.length >= 1) {
                props.setProjetos(response.data)
                props.setVazio(false)
                setPatrocinador("")
                setBeneficiario("")
                setAndamento("")
            } else {
                props.setVazio(true)
                setPatrocinador("")
                setBeneficiario("")
                setAndamento("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (patrocinador) prepQuery = prepQuery + `&patrocinador=${encodeURI(patrocinador)}`;
        if (beneficiario) prepQuery = prepQuery + `&beneficiario=${encodeURI(beneficiario)}`;
        if (andamento !== "false" && andamento !== "") prepQuery = prepQuery + `&andamento=${encodeURI(andamento)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="patrocinador">
                                <FloatingLabel
                                    label="Patrocinador/Doador"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="patrocinador"
                                        value={patrocinador}
                                        onChange={e => setPatrocinador(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="beneficiario">
                                <FloatingLabel
                                    label="Beneficiario"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="beneficiario"
                                        value={beneficiario}
                                        onChange={e => setBeneficiario(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Andamento">
                                <FloatingLabel
                                    label="Andamento"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="Andamento"
                                        name="andamento"
                                        onChange={e => setAndamento(e.target.value)}
                                    >
                                        <option>TODOS</option>
                                        <option value="Em Andamento">Em Andamento</option>
                                        <option value="Recursos Captados">Recursos Captados</option>
                                        <option value="Concluído">Concluído</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/renuncias/projetocultural'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
